import { DocumentRelationObject } from '../../../types';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const postDocumentRelation = async (
  constructPost: ConstructPost,
  documentId: string,
  documentParams: DocumentParams,
  data: DocumentRelationObject,
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructPost(
    `${DOCUMENTS_BASE_PATH}/${documentId}/related`,
    { data, headers: buildHeadersFromDocumentParams(documentParams) },
    { preventDefaultErrorToast: true },
  );
